<template>
    <div class="container">
        <div class="header-desktop-container header-desktop-container-mobile">
            <div class="d-flex align-center">
                <!-- <router-link style="margin: auto" v-if="user &&
            user.roles &&
            user.roles.length > 0 &&
            user.roles[0].employeeRole === 'Root'
            " to="/RestaurantRoot">
            <img src="../assets/img/arrowBack.svg" class="img-pluss-btn" alt="arrow-back" />
          </router-link> -->
                <router-link style="" to="/PortalUser">
                    <img src="../assets/img/arrowBack.svg" class="img-pluss-btn" alt="arrow-back" />
                </router-link>
                <h1 class="page-title">
                    {{ this.portalUserBody.name }}

                </h1>

            </div>



            <button @click="addRestaurantRole" class="btn-add">
                Добавить ресторан + роль
                <!-- <img class="save-icon" src="../assets/img/btn-save.svg" alt="save" /> -->
            </button>


        </div>
        <div class="content-container" ref="rolesContainer">
            <div v-if="restaurantRoles.length === 0" class="empty-message mt-5">
                У пользователя отсутствуют рестораны и роли.
                Нажмите "Добавить ресторан + роль", чтобы добавить.
            </div>

            <div class="search-component" v-for="(rr, index) in restaurantRoles" :key="rr.id || index" :ref="index === restaurantRoles.length - 1 ? 'lastRole' : null">
                <!-- Ресторан -->
                <!-- <p class="col-title">Ресторан <span class="red-dot">*</span></p> -->
                <p class="col-title">Ресторан</p>
                <v-autocomplete v-model="rr.restaurant.id" :items="restaurants" item-text="name" item-value="id"
                    hide-details solo class="input-css">
                    <template v-slot:item="{ item, isSelected }">
                        <div :class="['restaurant-item', { active: isSelected }]">
                            {{ item.name }} {{ item.address ?
                                `(${item.address})` : '' }}
                        </div>
                    </template>
                </v-autocomplete>

                <!-- Роль -->
                <p class="col-title">Роль</p>
                <v-autocomplete v-model="rr.role.id" :items="roles" item-text="name" item-value="id" hide-details solo
                    class="input-css">
                    <template v-slot:item="{ item, isSelected }">
                        <div :class="['restaurant-item', { active: isSelected }]">
                            {{ item.name }}
                        </div>
                    </template>
                </v-autocomplete>
                <div @click="removeRestaurantRole(index)" class="btn-delete">

                    <img class="save-icon" src="../assets/icons/gray-delete.svg" alt="save" />
                </div>



            </div>
        </div>



        <button  @click="saveRoles" class="btn-save">
            Сохранить
            <img class="save-icon" src="../assets/img/btn-save.svg" alt="save" />
        </button>

        <v-snackbar v-model="snackbar" timeout="3000" class="btn-contaiener">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
                    Закрыть
                </div>
            </template>
        </v-snackbar>
    </div>
</template>


<script>

export default {


    name: "PortalUserBody",
    data() {
        return {
            snackbar: false,
            message: "",
            portalUserBody: {},
            name: "",
            restaurantRoles: [],
            restaurants: [],
            restaurant: {},
            role: {},
            roles: [],

        }
    },

    created() {

        this.restList();
        this.roleList();

    },

    methods: {
        saveRoles() {
            // 1️⃣ Проверка: все ли строки заполнены
            const hasEmpty = this.restaurantRoles.some(
                rr => !rr.restaurant?.id || !rr.role?.id
            );
            if (hasEmpty) {
                this.snackbar = true;
                this.message = "Заполните все поля перед сохранением";
                return;
            }

            // 2️⃣ Проверка на дубли ресторанов
            const ids = this.restaurantRoles.map(rr => rr.restaurant.id);
            const hasDuplicates = ids.some((id, idx) => ids.indexOf(id) !== idx);
            if (hasDuplicates) {
                this.snackbar = true;
                this.message = "Нельзя сохранить два одинаковых ресторана";
                return;
            }

            // 3️⃣ Если всё ок — отправляем запрос
            const payload = this.restaurantRoles.map(rr => ({
                restaurantId: rr.restaurant.id,
                roleId: rr.role.id,
            }));

            this.$http
                .patch(`/api/PortalUser/${this.$route.params.portalUserId}/roles`, payload)
                .then(() => {
                    this.snackbar = true;
                    this.message = "Роль и ресторан успешно обновлена";
                    this.getPortalUser();
                })
                .catch((error) => {
                    console.error(error);
                    this.snackbar = true;
                    this.message = "Ошибка при добавлении роли и ресторана пользователю";
                });
        },
        addRestaurantRole() {
            this.restaurantRoles.push({
                restaurant: { id: null, name: "" },
                role: { id: null, name: "" },
            });
        this.$nextTick(() => {
        const lastRole = this.$refs.lastRole;
        if (lastRole && lastRole[0]) {
            lastRole[0].scrollIntoView({
            behavior: "smooth",
            block: "center"
            });
        }
        });
        },
        removeRestaurantRole(index) {
            this.restaurantRoles.splice(index, 1);
        },
        getPortalUser() {
            this.$http
                .get(`/api/PortalUser/${this.$route.params.portalUserId}`)
                .then((response) => {
                    this.portalUserBody = response.data;
                    this.name = this.portalUserBody.name || "Не указан";
                    this.restaurantRoles = (response.data.restaurantRoles || []).map(rr => ({
                        restaurant: rr.restaurant || { id: null, name: "" },
                        role: rr.role || { id: null, name: "" },
                    }));
                    // this.description = this.restaurant.description || "Не указан";
                    // this.phoneNumber = this.restaurant.phoneNumber || "Не указан";
                    // this.address = this.restaurant.address || "Не указан";
                    // this.minOrderAmount = this.restaurant.minOrderAmount ?? "Не указан";
                    // this.isUsingDelivery = this.restaurant.isUsingDelivery;
                    // this.isUsingBonus = this.restaurant.isUsingBonus;

                    this.loading = true;
                })
                .catch((error) => {
                    alert(error);
                });
        },
        restList() {
            this.$http

                .put("/api/Restaurant/PagedList", {
                    pageNumber: 1,
                    pageSize: -1,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    //             filters: [
                    //   {
                    //     property: "Name",
                    //     operator: "contains",
                    //     value: this.search.toLowerCase(),
                    //   }
                    // ],
                })
                .then((response) => {
                    this.restaurants = response.data.items.map((item) => ({
                        id: item.id, // Уникальный идентификатор
                        name: item.name || "Не указано",
                        address: item.address || "Не указан",
                    }));
                    //this.totalPages = response.data.totalPages; // Общее количество страниц
                    // this.totalItems = response.data.totalCount;
                    // this.showNoDataMessage = this.totalItems === 0;
                })
                .catch((error) => {
                    this.error = error;
                });
        },

        roleList() {
            this.$http

                .put("/api/Roles/PagedList", {
                    pageNumber: 1,
                    pageSize: -1,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    //             filters: [
                    //   {
                    //     property: "Name",
                    //     operator: "contains",
                    //     value: this.search.toLowerCase(),
                    //   }
                    // ],
                })
                .then((response) => {
                    this.roles = response.data.items.map((item) => ({
                        id: item.id, // Уникальный идентификатор
                        name: item.name || "Не указано",

                    }));
                    //this.totalPages = response.data.totalPages; // Общее количество страниц
                    // this.totalItems = response.data.totalCount;
                    // this.showNoDataMessage = this.totalItems === 0;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
    },
    mounted() {
        // this.initialize();
        //   this.getManufacturers();
        this.getPortalUser();
    },

}


</script>

<style scoped>
.content-container {
    border-radius: 8px;
    background: var(--white, #fff);
    margin-top: 16px;
    width: fit-content;
    padding: 0 24px 24px;
    max-height: 530px; /* или сколько нужно */
    overflow-y: auto;
    padding-right: 8px; /* чтобы скролл не наезжал */

}

.empty-message {
    font-family: Inter;
    font-style: normal;
    line-height: normal;
    font-weight: 500;
    font-size: 16px;
    color: #323c4d;
    max-width: 455px;
}

.snackbar-btn {
    color: var(--Red, #eb5757);
    font-family: Inter;
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    line-height: 1.25rem;
    margin-right: auto;
    padding: 14px 16px;
    text-align: initial;
    cursor: pointer;
}

.btn-delete {
    cursor: pointer;
    display: flex;


}

.save-icon {

    width: 21px;
    height: 30px;
}

.btn-add {
    width: fit-content;
    height: 36px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 5px 18px 5px 18px;
    border-radius: 5px;
    background: rgb(50, 60, 77);
    color: white;
    /* margin-left: 20px; */
}

.btn-save {
    width: 139px;
    height: 36px;
    left: 1750px;
    right: 31px;
    top: 86px;
    bottom: 958px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 5px 18px 5px 18px;
    border-radius: 5px;
    background: rgb(50, 60, 77);
    color: white;
    margin-top: 25px;
    /* margin-left: 20px; */
}

.header-desktop-container {
    display: flex;
    /* align-items: center; */
    justify-content: space-between;
}

.btn-modal-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 36.7px;
}

.modal-text {
    font-family: Inter;
    font-weight: 700;
    font-size: 24px;
    text-align: center;
    color: #323c4d;
    margin-bottom: 0px;
    line-height: normal;
}

.modal-container {
    padding: 20px 20px 37px 20px;
}

#accounts>.container {
    border-radius: 8px;
}

.chart-name-container {
    width: fit-content;
}

.input-container {
    display: flex;
    align-items: center;
    gap: 150px;
    margin-bottom: 10px;
    justify-content: space-between;
    padding: 0 9px 0;
}

.card-content-text {
    font-family: Inter;
    font-size: 20px;
    font-weight: 700;
    line-height: 24.2px;
    text-align: left;
    color: #323C4D;
    margin-bottom: 8px;
}

.card-item {
    background: #fff;
    /* max-width: 247px; */
    /* width: px; */
    border-radius: 5px;
    /* height: 620px; */
    display: flex;
    flex-direction: column;
    padding: 18px 18px 23px 18px;
}

.modal-card {
    background-color: #F8F8F8 !important;
}

.input-css {
    border-radius: 5px;
    padding: 10px 10px 10px 10px;
    /* height: 42px; */
    border: 1px solid transparent;
    outline: none;
    transition: border 0.3s ease;
    font-family: Inter;
    font-weight: 600;
    font-size: 15px;
    color: #323c4d;
}

.input-css-textarea:hover,
.input-css-textarea:focus {
    border: 1px solid #d4d4e1;
    /* Цвет бордера при наведении */
}

.input-css:hover,
.input-css:focus {
    border: 1px solid #d4d4e1;
    /* Цвет бордера при наведении */
}

.btn-create {
    /* width: 121px; */
    height: 36px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px 18px;
    border-radius: 5px;
    background: rgb(50, 60, 77);
    color: white;

}

/* Custom styles for the "Закрыть" button */
.custom-snackbar .v-btn--text.v-btn--success {
    color: #fff;
    /* White text color */
}

.custom-snackbar .v-btn--text.v-btn--success:hover {
    background-color: #357a38;
    /* Darker green background on hover */
}

.role-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.border-hover {
    border-radius: 8px;
    border: 1px solid var(--03, #c1c1c1) !important;
    /* Другие стили по вашему усмотрению */
}

.v-col.cols-7 .border-hover {
    border-radius: 8px;
    border: 1px solid var(--03, #c1c1c1) !important;
    background: var(--white, #fff);
}

.profile-menu-item:hover {
    /* Здесь вы можете задать стили для hover-эффекта */
    background-color: #f0f0f0;
    /* Пример: изменение цвета фона при наведении */
    color: #333;
    /* Пример: изменение цвета текста при наведении */
    cursor: pointer;
    /* Пример: изменение курсора при наведении */
    /* Другие стили по вашему усмотрению */
}

.border-input {
    border-radius: 8px;
    border: 1px solid var(--03, #c1c1c1) !important;
    background: var(--white, #fff);
    padding: 6px;
}

.border-white {
    border-radius: 8px;
    border: 1px solid var(--02, white);
    background: var(--white, #fff);
    padding: 6px;
    cursor: pointer;
    width: 100%;
}

.divider-modal {
    background: #e0e0e0;
    height: 1px;
    width: 100%;
    /* Расширяем на всю ширину родительского контейнера */
}

.profile-menu-item {
    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 0px;
    padding-left: 30px;
    padding-top: 11px;
    padding-bottom: 11px;
    width: 100%;
}

.input-menu {
    position: absolute;
    bottom: 32%;
    left: 30.7%;
    width: 347px;
    height: auto;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0px 0px 30px 0px rgba(200, 200, 200, 0.52);
    transition: bottom 0.3s;
    padding: 0px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    z-index: 100;
    /* right: -15px; */
}

.select-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    /* margin-left: 15px; */
}

.option-btn {
    margin-bottom: 0px;
    color: var(--Gray-1, #333);
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    /* 146.667% */
    margin-left: 5px;
}

::v-deep .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}

.btn-container {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 46px;
    align-items: center;
    margin-right: 20px;
}

.red-dot-margin-2 {
    margin-left: -17px;
}

.red-dot-margin-1 {
    text-align: center;
    margin-left: -17px;
}

.btn-contaiener {
    display: flex;
    justify-content: space-evenly;
}

.cancel-btn {
    color: #eb5757;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border-radius: 8px;
    display: inline-flex;
    padding: 13px 29px;
    cursor: pointer;

}

.delete-btn {
    color: var(--Red, #eb5757);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
}

.snackbar-btn {
    color: var(--Red, #eb5757);
    font-family: Inter;
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    line-height: 1.25rem;
    margin-right: auto;
    padding: 14px 16px;
    text-align: initial;
    cursor: pointer;

}

.save-btn {
    color: #fff;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border-radius: 8px;
    background: #323C4D;
    display: inline-flex;
    padding: 13px 29px;
    justify-content: center;
    align-items: center;
    gap: 32.5px;
    cursor: pointer;
}

.del-btn {
    color: #fff;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border-radius: 8px;
    background: #e41313;
    display: inline-flex;
    padding: 13px 29px;
    justify-content: center;
    align-items: center;
    cursor: pointer;

}

.text-limit {
    width: 30ch;
    /* Отображение примерно 10 символов */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow: hidden;
    color: var(--Gray-1, #333);
    text-overflow: ellipsis;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    /* 146.667% */
    margin-bottom: 0px;
}

.horizontal-line {

    height: 1px;
    width: 100%;
    background: #D4D4E1;

}

.custom-select {
    position: relative;
    width: 350px;
    cursor: pointer;
    /* margin-left: 9px; */
    color: var(--gray-1, #333);
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    /* 146.667% */
}

.select-arrow {
    position: absolute;
    top: 40%;
    right: 30px;
    /* transform: translateY(-50%); */
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #333;
    /* Цвет стрелочки */
}

.col-description,
:focus {
    outline: none;
    /* Убираем внешний контур (outline) при фокусе */
    border: none;
    /* Убираем границу (border) при фокусе */
    box-shadow: none;
    /* Убираем тень (box-shadow) при фокусе */
}

.red-dot {
    color: #e41313;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.col-title {
    color: var(--gray-1, #333);
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    word-wrap: break-word;
    margin-bottom: 0px;
    /* margin-right: 25px; */
}

.col-paddings-r-l {
    padding-right: 0px;
    padding-left: 0px;
}

.col-content {
    display: flex;
    flex-direction: column;
}

.role-margin {
    margin-right: 37px;
}

.role-margin-1 {
    margin-right: 30px;
}

.col-content-2 {
    display: flex;
    align-items: center;
    width: fit-content;
}

.col-description {
    color: var(--gray-1, #333);
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    /* 146.667% */
    margin-bottom: 0px;
    word-wrap: break-word;
    resize: none;
    height: 30px;
    /* min-height: 20px; */
    width: 100%;
    /* margin-left: 18px; */
}

::v-deep .v-dialog {
    /* border-radius: 20px; */
    background: #F8F8F8;
    margin: 24px;
    overflow-y: auto;
    pointer-events: auto;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    width: 100%;
    z-index: inherit;
    box-shadow: none;
}

.modal-title {
    color: var(--gray-1, #333);
    font-family: Inter !important;
    font-size: 24px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: normal;
}

.page-title {
    font-family: Inter;
    font-weight: 700;
    font-size: 24px;
    color: #323c4d;
    margin-bottom: 0px;
}

.vertical-line {
    width: 1px;
    height: 42px;
    background: #e0e0e0;
    margin-left: 31px;
}

.vertical-line-1 {
    width: 1px;
    height: 50px;
    background: #e0e0e0;
}

.add-btn .add-text {
    color: var(--01, #333);
    text-align: center;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 0px;
    margin-left: 12px;
    transition: color 0.3s ease;
}

.add-btn:hover .add-text {
    /* Цвет текста при наведении */
    color: black;
    /* Замените "red" на желаемый цвет текста */
    font-weight: 500;
    font-size: 17px;
}

.add-btn {
    display: flex;
    align-items: center;
    padding: 12px 0px;
    margin-left: 37px;
    cursor: pointer;
}

.top-panel {
    height: 31px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 14px;
}

.search-container {
    padding-left: 40px;
    padding-right: 30px;
    padding-top: 17px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.img-pluss-btn {
    margin-left: 10px;
}

.arrow-btn {
    /* border-right: 1px solid var(--04, #eaeaea); */
    width: 56px;
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.search-notfound {
    /* display: flex; */
    margin: 0 auto;
    font-family: "Inter";
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
}

.search-component {
    max-width: 796px;
    width: 100%;
    /* height: 45px; */
    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 25px;
    padding: 10px 0;
    border-bottom: 1px solid #D4D4E1;
}

.search-component__input {
    border: 1px solid rgb(224, 224, 224);
    border-radius: 5px;
    width: 100%;
    outline: unset;
    padding: 0 40px 0 15px;
    display: flex;
    align-items: center;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
}


.search-component__icon {
    position: absolute;
    top: 14.5px;
    right: 15px;
}

#staff-add-button {
    border-radius: 8px;
    background-color: #333;
    color: var(--white, #fff);
    gap: 12px;
    padding: 10px 56px;
    text-align: center;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    height: 45px;
}

::v-deep tbody tr:nth-child(2n) {
    background: rgba(242, 242, 246, 0.5);
}

::v-deep .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
    color: var(--gray-1, #333) !important;
    font-family: Inter;
    font-size: 16px !important;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

::v-deep .v-data-table__wrapper>table>thead>tr>th {
    color: #606c80 !important;
    font-family: Inter;
    font-size: 16px !important;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-wrap: nowrap;

}

::v-deep .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr:last-child>th {
    border-bottom: 2px solid #606c80;
}

.nav-container {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

::v-deep .v-autocomplete__content.v-menu__content {
    color: #000;
    background-color: #000;
    background: #000;
}

::v-deep .v-autocomplete__content .v-list-item__title {
    color: black;
    /* Цвет текста */
}

::v-deep .v-autocomplete__content.v-menu__content {
    color: #000;
    background-color: #000;
    background: #000;
}

::v-deep .v-autocomplete.v-input--outlined .v-input__control {
    border: none !important;
}

::v-deep .v-autocomplete__content.v-menu__content .v-select-list {
    border-radius: 0 0 4px 4px;
    background: green;
}

.img-pluss-btn {
    cursor: pointer;
    height: 100%;
    display: flex;
    margin-right: 17px;

}

.page-title {
    font-family: Inter;
    font-weight: 700;
    font-size: 19px;
    color: #323c4d;
    line-height: normal;
}

::v-deep .v-autocomplete__content input {
    border: 1px solid rgb(224, 224, 224);
    border-radius: 5px;
    width: 100%;
    outline: unset;
    padding: 0 40px 0 15px;
    display: flex;
    align-items: center;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
    box-shadow: none !important;
    /* border: 1px solid rgb(224, 224, 224); */
}

::v-deep .v-text-field--outlined fieldset {
    border: none !important;
}

.restaurant-item {
    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.restaurant-item :first-child {
    /* padding-left: 10px; */
    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: #000 !important;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 0px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 0px;
    padding-bottom: 0px;
    width: 100%;
    border-bottom: 0.5px solid rgb(212, 212, 225);
}


@media (min-width: 1264px) {
    .container {
        max-width: 100% !important;
    }
}

@media (min-width: 960px) {
    .container {
        max-width: 100% !important;
    }
}

@media (max-width: 650px) {
    .header-desktop-container-mobile {
        display: flex;
        /* align-items: center; */
        flex-direction: column;
        margin-top: 24px;

    }
}

@media (max-width: 1069px) {
    .header-desktop-container-mobile {
        display: flex;
        /* align-items: center; */
        flex-direction: column;
        margin-top: 24px;
        gap: 15px;

    }

    .v-card__title {
        flex-wrap: nowrap;
    }

    .modal-title {
        color: #323c4d;
        font-family: Inter !important;
        font-size: 24px !important;
        font-style: normal;
        font-weight: 600 !important;
        line-height: normal;
        word-break: auto-phrase;
    }

    .input-container {
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
        margin-bottom: 10px;
    }

    .v-data-footer__select {
        display: flex;
        align-items: center;
        flex: 1 1 auto;
        justify-content: flex-start;
        white-space: normal;
        width: 200px;
    }

    .search-component {
        /* max-width: fit-content; */
        width: 100%;
        /* height: 45px; */
        display: flex;
        position: relative;
        flex-direction: column;
        justify-content: flex-start;
    }

    .top-panel {
        height: 31px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: 24px;
    }

    .content-container {
        width: 100%;
        padding: 0 12px 24px;
    }
}
</style>
